export const ADRESS_GET_REQUEST = 'ADRESS_GET_REQUEST'
export const ADRESS_GET_SUCCESS = 'ADRESS_GET_SUCCESSS'
export const ADRESS_GET_FAIL = 'ADRESS_GET_FAIL'
export const ADRESS_UPDATE_REQUEST = 'ADRESS_UPDATE_REQUEST'
export const ADRESS_UPDATE_SUCCESS = 'ADRESS_UPDATE_SUCCESS'
export const ADRESS_UPDATE_FAIL = 'ADRESS_UPDATE_FAIL'